import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';

import { createChart } from 'lightweight-charts';
import {BackendApiService} from '../services/backend-api.service';
import { BackendSocketService } from '../services/backend-socket.service';
import {ActivatedRoute, Router,NavigationEnd} from '@angular/router';
import _ from "lodash";
import * as $ from 'jquery';
import { interval } from 'rxjs';

@Component({
  selector: 'app-lightchart',
  templateUrl: './lightchart.component.html',
  styleUrls: ['./lightchart.component.scss']
})
export class LightchartComponent implements OnInit {

  @ViewChild('chart', { static: true })
  chart: ElementRef;

  title = 'light-view';
  chartError :any = false;
  selectedDuration :any = "1";
  selectedMin :any = "1";
  instrumentId : any;
  candlestickSeries : any;
  areaSeries : any;
  chartOpn : any;
  subscription;
  randomString = this.getRandomString(5);
  instrumentCP : any = 0; 
  historyCloseRate : any;

  constructor(  private route: ActivatedRoute,
                private router: Router,
                private backendApiService: BackendApiService,
                private backendSocketService: BackendSocketService
              ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if(params){
        this.instrumentId = params.instId;
        let transactionObj = {
          "instrumentToken":params.instId,
          "filterparam":"5min"
        }
        this.backendApiService.getHistoryData(transactionObj).subscribe(response => {
          if(response.status == true){
               let searisAry = _.map(response.data, function (res) {
                  const d = new Date(res[0]);
                  let newTm =  Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds()) / 1000;
                  return {time: newTm, value: res[1]}
              })
              let candlestickAry = _.map(response.data, function (res) {
                const d = new Date(res[0]);
                let newTm =  Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds()) / 1000;
                return {time: newTm, open: res[1],high: res[2], low:  res[3], close: res[4]}
              })
              if(response.data.length > 0){
                let lastElement = response.data.length - 1;
                this.instrumentCP = response.data[lastElement][4];  
                this.historyCloseRate = response.data[lastElement];
              }

              let chartElement = this.chart.nativeElement;
              this.chartOpn = createChart(chartElement, { width: 100, height: 100 })
         
              this.areaSeries = this.chartOpn.addAreaSeries();
              this.areaSeries.setData(searisAry);
    
              this.candlestickSeries = this.chartOpn.addCandlestickSeries();
              this.candlestickSeries.setData(candlestickAry);
              
              this.chartOpn.applyOptions({
                timeScale: {
                    visible: true,
                    timeVisible: true,
                    secondsVisible: false
                },
                width: $('#chartDiv').width(), 
                height: $('#chartDiv').height()
            });
            
            this.chartOpn.timeScale().fitContent();
            // setInterval(() => {
            //     this.realTimeUpdate("s")
            // }, 1000);
          }else{
            this.chartError = true;
          }
        })
        // this.callSocketRate(this.instrumentId + "_full");
        // this.getRate();
      }else{
      }
    });

 
  }

  onDurationSelectec(value:string){
    console.log('this++++',this.selectedDuration);      
    if(this.selectedDuration != "1"){
      this.selectedMin = "5"
    }else{
      this.selectedMin = "1"
    }
  }

  onDurationMin(value:string){
  }

  updateChart(){
      let obj = {
        "instrumentToken":this.instrumentId,
        "filterparam":"5min",
        "timeDuration":""
      }
      if(this.selectedDuration == "1" && this.selectedMin == "1"){
        obj.filterparam = "5min";
      }else if(this.selectedDuration == "1" && this.selectedMin == "2"){
        obj.filterparam = "15min";
      }else if(this.selectedDuration == "1" && this.selectedMin == "3"){
        obj.filterparam = "30min";
      }else if(this.selectedDuration == "1" && this.selectedMin == "4"){
        obj.filterparam = "1hr";
      }else if(this.selectedDuration != "1" && this.selectedMin == "5"){
        obj.filterparam = "1day";
        obj.timeDuration = (this.selectedDuration == "2") ? "1week" : (this.selectedDuration == "3") ? "1month" :"1year" ;
       }
      this.reInitChart(obj)
  }
  
  reInitChart(transactionObj){
    // let transactionObj = {
    //   "instrumentToken":this.instrumentId,
    //   "filterparam":"5min"
    // }
    this.backendApiService.getHistoryData(transactionObj).subscribe(response => {
      if(response.status == true){
        this.chartOpn.removeSeries(this.areaSeries)
        this.chartOpn.removeSeries(this.candlestickSeries)
        this.chartOpn = null;
        $('#chartDiv').find('div').first().remove();

        let searisAry = _.map(response.data, function (res) {
          const d = new Date(res[0]);
          let newTm =  Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds()) / 1000;
          return {time: newTm, value: res[1]}
          })
        let candlestickAry = _.map(response.data, function (res) {
          const d = new Date(res[0]);
          let newTm =  Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds()) / 1000;
          return {time: newTm, open: res[1],high: res[2], low:  res[3], close: res[4]}
        })
        
        let chartElement = this.chart.nativeElement;
        this.chartOpn = createChart(chartElement, { width: 100, height: 500 })
   
        this.areaSeries = this.chartOpn.addAreaSeries();
        this.areaSeries.setData(searisAry);

        this.candlestickSeries = this.chartOpn.addCandlestickSeries();
        this.candlestickSeries.setData(candlestickAry);
        this.chartOpn.applyOptions({
          timeScale: {
              visible: true,
              timeVisible: true,
              secondsVisible: false
          },
          width: $('#chartDiv').width(), 
          height: $('#chartDiv').height()
      });

      this.chartOpn.timeScale().fitContent();

      }else{
        this.chartError = true;
      }
    })
  }

  realTimeUpdate(updateObj){
      const d = new Date();
      let newTm =  Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds()) / 1000;
      let serialObj = {
        "time": newTm,
        "value": updateObj['close']
      }
      let candlestickObj = {
        "time": newTm,
        "open": updateObj['open'],
        "high": updateObj['high'],
        "low": updateObj['low'],
        "close": updateObj['close']
      }
      // console.log('serialObj+++++++',serialObj);
      // console.log('candlestickObj+++++++',candlestickObj);
      
     
      this.candlestickSeries.update(candlestickObj);
      this.areaSeries.update(serialObj);
  }

  callSocketRate(tokens){
    let uniqId = "";
    let tokenIds =  tokens.toString();
    //socket service market join
    var requested = {
                  "roomId": this.randomString,
                  "instrument_token": tokenIds,
                  "uniqId":this.getRandomString(10),
                  "response_type" : 'full'
                };
          // this.socketServiceBbMarket.leaveRoom(this.randomString);
          // this.socketServiceBbMarket.joinRoom(JSON.stringify(requested));
          if(this.subscription){
            this.clearSubscription(this.subscription);
          }
          var observable = interval(1000);
          this.subscription = observable.subscribe(x => {
            this.backendSocketService.setInstrument(JSON.stringify(requested));
          });
  }

  getRandomString(length){
      var result           = '';
      var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
  }


  clearSubscription(timer){
    let storeTimer = timer;
    setTimeout(function(){
      //storeTimer.unsubscribe();
    },3000);
  }

  getRate(){
    this.backendSocketService
    .getInstrument()
    .subscribe((response) => {
      if(response){
        if(response.data[0]['last_price']){
          let updateObj = {
            "open": this.historyCloseRate[1] ? this.historyCloseRate[1] : response.data[0]['ohlc']['open'],
            "high": this.historyCloseRate[2] ? this.historyCloseRate[2] : response.data[0]['ohlc']['high'],
            "low": this.historyCloseRate[3] ? this.historyCloseRate[3] : response.data[0]['ohlc']['low'],
            "close": response.data[0]['last_price']
          }
          if(this.instrumentCP !== response.data[0]['last_price']){
              //this.realTimeUpdate(updateObj);
              //this.instrumentCP = response.data[0]['last_price'];
          }
        }
      }
    })
  }

}
